import { GraphQLErrors } from '@apollo/client/errors';

export const isGraphQLError = (graphQLErrors?: GraphQLErrors): boolean =>
  !(
    !!graphQLErrors &&
    ['EXPORT_DATA'].includes(graphQLErrors[0].extensions.code as string)
  );
